export function PlainLogoSVG() {
  return (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="50" height="50" viewBox="0 0 200 200" enable-background="new 0 0 200 200" xmlSpace="preserve">
<path fill="#2BE58B" opacity="1.000000" stroke="none" 
	d="
M96.000000,201.000000 
	C64.000000,201.000000 32.500004,201.000000 1.000004,201.000000 
	C1.000003,134.333344 1.000003,67.666679 1.000001,1.000013 
	C67.666656,1.000009 134.333313,1.000009 200.999969,1.000004 
	C200.999985,67.666649 200.999985,134.333298 201.000000,200.999969 
	C166.166672,201.000000 131.333328,201.000000 96.000000,201.000000 
M52.531151,147.159225 
	C52.240902,147.369812 52.085903,147.654144 52.002701,148.008926 
	C52.002701,148.008926 52.025223,148.068344 51.454029,148.419174 
	C50.273243,150.065598 49.092453,151.712021 46.977242,154.661346 
	C50.644131,154.661346 52.829014,154.661346 55.765842,154.813568 
	C56.527592,154.761597 57.289345,154.709625 58.761444,154.825592 
	C59.484356,154.769073 60.207268,154.712540 61.776379,154.810059 
	C63.204365,154.759399 64.632347,154.708755 66.974556,154.833282 
	C75.289520,154.774902 83.604477,154.716537 92.736923,154.806580 
	C93.839386,154.751022 94.941841,154.695465 96.852135,154.762299 
	C105.312157,153.948380 113.013939,151.401001 119.000000,145.000000 
	C119.000000,145.000000 119.051414,145.052643 119.651245,144.777588 
	C121.155350,142.892593 122.659447,141.007614 124.035782,139.035797 
	C124.035782,139.035797 124.136688,139.152786 124.703613,138.765579 
	C126.464630,134.540924 129.389435,130.403610 129.714615,126.071182 
	C130.205551,119.530029 132.409256,115.061424 138.527313,112.585121 
	C138.527313,112.585121 138.566696,112.521515 139.161270,112.233452 
	C156.400604,98.883705 159.035431,75.225922 144.971146,60.034809 
	C144.971146,60.034809 144.867477,60.028633 144.620331,59.438763 
	C143.187988,58.174404 141.755630,56.910042 139.992096,55.936672 
	C139.992096,55.936672 140.330444,55.657532 139.947678,55.114689 
	C133.572006,50.172825 126.365883,47.707317 118.284264,47.752338 
	C111.164330,47.792007 103.986359,48.325024 96.938263,47.611095 
	C87.924294,46.698048 82.071068,50.475101 77.960342,57.947914 
	C77.960342,57.947914 77.947174,57.875259 77.471573,58.088215 
	C77.312706,58.388729 77.153839,58.689240 76.536758,59.237076 
	C76.364105,59.532604 76.191460,59.828133 75.449722,60.445358 
	C71.251450,65.593971 67.053177,70.742577 62.926323,75.904861 
	C62.926323,75.904861 62.931828,75.832352 62.441013,76.056267 
	C62.268040,76.362053 62.095066,76.667847 61.986889,76.989510 
	C61.986889,76.989510 61.951965,76.932678 61.369072,77.257133 
	C60.242523,78.790741 59.115971,80.324341 57.328091,82.758240 
	C60.133373,83.031982 61.851383,83.334618 63.571079,83.344536 
	C71.886070,83.392471 80.208466,83.574142 88.514954,83.302383 
	C97.854698,82.996826 106.714287,84.379723 114.993866,89.011086 
	C114.993866,89.011086 114.867226,89.133827 115.209450,89.681801 
	C116.762619,90.840492 118.315788,91.999184 119.888275,93.087204 
	C119.888275,93.087204 119.815315,93.080658 120.033203,93.585732 
	C120.335457,93.779808 120.637718,93.973885 120.928612,94.096283 
	C120.928612,94.096283 120.859291,94.117729 121.107399,94.752586 
	C123.392441,98.399971 126.409515,101.785561 127.825119,105.743874 
	C132.051956,117.563049 132.122162,118.161018 119.155724,118.864258 
	C108.036980,119.467278 96.837082,119.431313 85.716385,118.849808 
	C77.872627,118.439659 72.641258,121.418777 68.999496,127.999039 
	C68.999496,127.999039 68.921890,127.929695 68.351448,128.266586 
	C65.497757,131.810074 62.644062,135.353577 59.368294,139.079910 
	C59.117134,139.286804 58.977200,139.552322 58.475479,140.099243 
	C58.314663,140.398468 58.153843,140.697678 58.000168,141.000000 
	C58.000168,141.000000 57.995350,140.993683 57.456985,141.281982 
	C56.874184,142.097122 56.291386,142.912262 55.971363,144.003586 
	C55.971363,144.003586 55.719105,143.720459 55.196350,143.995117 
	C54.751747,144.636688 54.307148,145.278259 53.947475,145.940414 
	C53.947475,145.940414 53.958939,145.853775 53.460350,146.062164 
	C53.291645,146.371445 53.122944,146.680740 53.004932,146.999985 
	C53.004932,146.999985 52.985771,146.952011 52.531151,147.159225 
z"/>
<path fill="#0A2617" opacity="1.000000" stroke="none" 
	d="
M76.018814,60.123661 
	C76.191460,59.828133 76.364105,59.532604 76.958969,58.959343 
	C77.621834,58.449326 77.810501,58.180542 77.947174,57.875259 
	C77.947174,57.875259 77.960342,57.947914 78.286682,57.910255 
	C80.323433,56.644375 82.577477,55.765045 83.634705,54.117649 
	C86.077393,50.311375 89.429550,49.849243 93.452896,49.923931 
	C102.723808,50.096039 112.002892,49.851883 121.272514,50.055687 
	C124.165634,50.119297 127.114594,50.830734 129.902588,51.686646 
	C133.450516,52.775852 136.860809,54.313316 140.330444,55.657532 
	C140.330444,55.657532 139.992096,55.936672 140.154861,56.152275 
	C140.551743,59.182117 141.464447,61.152958 144.867477,60.028633 
	C144.867477,60.028633 144.971146,60.034809 144.998871,60.446793 
	C145.944473,62.796669 146.668686,64.857880 147.811539,66.652512 
	C155.438675,78.629562 152.326599,99.424904 141.713974,107.178055 
	C140.181534,108.297585 139.592377,110.708313 138.566696,112.521515 
	C138.566696,112.521515 138.527313,112.585121 138.121765,112.523514 
	C136.034576,112.704239 134.352905,112.946564 132.659805,113.190544 
	C132.517700,111.141777 132.902191,109.276649 132.204056,108.006676 
	C130.093323,104.167076 127.715073,100.445938 125.115021,96.918999 
	C124.169556,95.636475 122.304688,95.031715 120.859291,94.117722 
	C120.859291,94.117729 120.928612,94.096283 120.784225,93.914314 
	C120.365005,93.515114 120.090157,93.297890 119.815315,93.080658 
	C119.815315,93.080658 119.888275,93.087204 119.822098,92.771042 
	C118.126358,91.347855 116.496796,90.240837 114.867226,89.133827 
	C114.867226,89.133827 114.993866,89.011086 114.842392,88.748703 
	C110.566742,83.829369 105.016113,82.300102 99.185799,82.099380 
	C90.601021,81.803841 81.998657,82.019127 73.403778,82.017387 
	C69.652802,82.016632 65.901817,82.017258 61.951965,82.017258 
	C61.951965,79.820793 61.951965,78.376732 61.951965,76.932678 
	C61.951965,76.932678 61.986889,76.989510 62.158089,76.824837 
	C62.530132,76.384224 62.730980,76.108292 62.931828,75.832352 
	C62.931828,75.832352 62.926323,75.904861 63.233299,75.839066 
	C69.405563,71.916870 73.690315,66.800194 76.018814,60.123661 
z"/>
<path fill="#092A18" opacity="1.000000" stroke="none" 
	d="
M66.060333,154.658096 
	C64.632347,154.708755 63.204365,154.759399 61.129902,154.605392 
	C59.672649,154.486359 58.861874,154.572006 58.051098,154.657654 
	C57.289345,154.709625 56.527592,154.761597 55.284172,154.428757 
	C53.876743,152.052078 52.950981,150.060211 52.025223,148.068344 
	C52.025223,148.068344 52.002701,148.008926 52.217194,147.861145 
	C52.660992,147.492050 52.845688,147.238266 52.985771,146.952011 
	C52.985771,146.952011 53.004932,146.999985 53.177074,146.833954 
	C53.552460,146.396545 53.755699,146.125153 53.958939,145.853775 
	C53.958939,145.853775 53.947475,145.940414 54.202751,145.829422 
	C54.878387,145.052444 55.298744,144.386444 55.719105,143.720459 
	C55.719105,143.720459 55.971363,144.003586 56.162632,143.801819 
	C56.901051,142.731247 57.448204,141.862473 57.995354,140.993683 
	C57.995350,140.993683 58.000168,141.000000 58.184975,140.837708 
	C58.606567,140.440903 58.799469,140.174576 58.948490,139.876465 
	C58.977200,139.552322 59.117134,139.286804 59.925987,138.929733 
	C64.348648,135.981277 68.537949,133.435257 68.921890,127.929695 
	C68.921890,127.929695 68.999496,127.999039 69.300339,127.898514 
	C71.398186,126.356293 73.078674,124.726349 75.023117,123.522873 
	C77.215439,122.165970 79.623863,120.260315 81.975433,120.206161 
	C95.962715,119.883995 109.962776,119.921196 123.951942,120.186111 
	C125.320053,120.212029 127.652313,122.519081 127.771446,123.917694 
	C127.999565,126.595711 127.079506,129.412216 126.406487,132.114105 
	C125.811996,134.500702 124.905449,136.809586 124.136688,139.152786 
	C124.136688,139.152786 124.035782,139.035797 123.733437,139.129944 
	C120.199280,139.835495 118.810455,141.831741 119.051414,145.052643 
	C119.051414,145.052643 119.000000,145.000000 118.653755,145.042664 
	C113.884003,147.139343 109.494675,149.271790 105.024872,151.219559 
	C102.091522,152.497757 99.041870,153.509064 96.044304,154.639893 
	C94.941841,154.695465 93.839386,154.751022 91.954353,154.580017 
	C82.801300,154.455017 74.430817,154.556549 66.060333,154.658096 
z"/>
<path fill="#023C19" opacity="1.000000" stroke="none" 
	d="
M124.420151,138.959183 
	C124.905449,136.809586 125.811996,134.500702 126.406487,132.114105 
	C127.079506,129.412216 127.999565,126.595711 127.771446,123.917694 
	C127.652313,122.519081 125.320053,120.212029 123.951942,120.186111 
	C109.962776,119.921196 95.962715,119.883995 81.975433,120.206161 
	C79.623863,120.260315 77.215439,122.165970 75.023117,123.522873 
	C73.078674,124.726349 71.398186,126.356293 69.263115,127.861893 
	C72.641258,121.418777 77.872627,118.439659 85.716385,118.849808 
	C96.837082,119.431313 108.036980,119.467278 119.155724,118.864258 
	C132.122162,118.161018 132.051956,117.563049 127.825119,105.743874 
	C126.409515,101.785561 123.392441,98.399971 120.983345,94.435150 
	C122.304688,95.031715 124.169556,95.636475 125.115021,96.918999 
	C127.715073,100.445938 130.093323,104.167076 132.204056,108.006676 
	C132.902191,109.276649 132.517700,111.141777 132.659805,113.190544 
	C134.352905,112.946564 136.034576,112.704239 138.084839,112.517593 
	C132.409256,115.061424 130.205551,119.530029 129.714615,126.071182 
	C129.389435,130.403610 126.464630,134.540924 124.420151,138.959183 
z"/>
<path fill="#023C19" opacity="1.000000" stroke="none" 
	d="
M140.139069,55.386108 
	C136.860809,54.313316 133.450516,52.775852 129.902588,51.686646 
	C127.114594,50.830734 124.165634,50.119297 121.272514,50.055687 
	C112.002892,49.851883 102.723808,50.096039 93.452896,49.923931 
	C89.429550,49.849243 86.077393,50.311375 83.634705,54.117649 
	C82.577477,55.765045 80.323433,56.644375 78.252991,57.895168 
	C82.071068,50.475101 87.924294,46.698048 96.938263,47.611095 
	C103.986359,48.325024 111.164330,47.792007 118.284264,47.752338 
	C126.365883,47.707317 133.572006,50.172825 140.139069,55.386108 
z"/>
<path fill="#023C19" opacity="1.000000" stroke="none" 
	d="
M61.660519,77.094910 
	C61.951965,78.376732 61.951965,79.820793 61.951965,82.017258 
	C65.901817,82.017258 69.652802,82.016632 73.403778,82.017387 
	C81.998657,82.019127 90.601021,81.803841 99.185799,82.099380 
	C105.016113,82.300102 110.566742,83.829369 114.784981,88.815781 
	C106.714287,84.379723 97.854698,82.996826 88.514954,83.302383 
	C80.208466,83.574142 71.886070,83.392471 63.571079,83.344536 
	C61.851383,83.334618 60.133373,83.031982 57.328091,82.758240 
	C59.115971,80.324341 60.242523,78.790741 61.660519,77.094910 
z"/>
<path fill="#023C19" opacity="1.000000" stroke="none" 
	d="
M138.863983,112.377487 
	C139.592377,110.708313 140.181534,108.297585 141.713974,107.178055 
	C152.326599,99.424904 155.438675,78.629562 147.811539,66.652512 
	C146.668686,64.857880 145.944473,62.796669 144.994919,60.498573 
	C159.035431,75.225922 156.400604,98.883705 138.863983,112.377487 
z"/>
<path fill="#023C19" opacity="1.000000" stroke="none" 
	d="
M96.448219,154.701111 
	C99.041870,153.509064 102.091522,152.497757 105.024872,151.219559 
	C109.494675,149.271790 113.884003,147.139343 118.680023,145.068359 
	C113.013939,151.401001 105.312157,153.948380 96.448219,154.701111 
z"/>
<path fill="#023C19" opacity="1.000000" stroke="none" 
	d="
M75.734268,60.284508 
	C73.690315,66.800194 69.405563,71.916870 63.197590,75.832230 
	C67.053177,70.742577 71.251450,65.593971 75.734268,60.284508 
z"/>
<path fill="#023C19" opacity="1.000000" stroke="none" 
	d="
M51.739624,148.243759 
	C52.950981,150.060211 53.876743,152.052078 54.908203,154.352646 
	C52.829014,154.661346 50.644131,154.661346 46.977242,154.661346 
	C49.092453,151.712021 50.273243,150.065598 51.739624,148.243759 
z"/>
<path fill="#023C19" opacity="1.000000" stroke="none" 
	d="
M68.636673,128.098145 
	C68.537949,133.435257 64.348648,135.981277 60.137024,138.838318 
	C62.644062,135.353577 65.497757,131.810074 68.636673,128.098145 
z"/>
<path fill="#023C19" opacity="1.000000" stroke="none" 
	d="
M66.517441,154.745697 
	C74.430817,154.556549 82.801300,154.455017 91.545609,154.505829 
	C83.604477,154.716537 75.289520,154.774902 66.517441,154.745697 
z"/>
<path fill="#023C19" opacity="1.000000" stroke="none" 
	d="
M119.351334,144.915115 
	C118.810455,141.831741 120.199280,139.835495 123.797318,139.173355 
	C122.659447,141.007614 121.155350,142.892593 119.351334,144.915115 
z"/>
<path fill="#023C19" opacity="1.000000" stroke="none" 
	d="
M144.743896,59.733696 
	C141.464447,61.152958 140.551743,59.182117 140.320465,56.006783 
	C141.755630,56.910042 143.187988,58.174404 144.743896,59.733696 
z"/>
<path fill="#023C19" opacity="1.000000" stroke="none" 
	d="
M115.038338,89.407814 
	C116.496796,90.240837 118.126358,91.347855 119.812439,92.806374 
	C118.315788,91.999184 116.762619,90.840492 115.038338,89.407814 
z"/>
<path fill="#023C19" opacity="1.000000" stroke="none" 
	d="
M57.726170,141.137833 
	C57.448204,141.862473 56.901051,142.731247 56.031242,143.663712 
	C56.291386,142.912262 56.874184,142.097122 57.726170,141.137833 
z"/>
<path fill="#023C19" opacity="1.000000" stroke="none" 
	d="
M55.457726,143.857788 
	C55.298744,144.386444 54.878387,145.052444 54.160286,145.819122 
	C54.307148,145.278259 54.751747,144.636688 55.457726,143.857788 
z"/>
<path fill="#023C19" opacity="1.000000" stroke="none" 
	d="
M58.406273,154.741623 
	C58.861874,154.572006 59.672649,154.486359 60.706802,154.528381 
	C60.207268,154.712540 59.484356,154.769073 58.406273,154.741623 
z"/>
<path fill="#023C19" opacity="1.000000" stroke="none" 
	d="
M119.924255,93.333191 
	C120.090157,93.297890 120.365005,93.515114 120.789917,93.950150 
	C120.637718,93.973885 120.335457,93.779808 119.924255,93.333191 
z"/>
<path fill="#023C19" opacity="1.000000" stroke="none" 
	d="
M58.711983,139.987854 
	C58.799469,140.174576 58.606567,140.440903 58.181404,140.836166 
	C58.153843,140.697678 58.314663,140.398468 58.711983,139.987854 
z"/>
<path fill="#023C19" opacity="1.000000" stroke="none" 
	d="
M53.709648,145.957977 
	C53.755699,146.125153 53.552460,146.396545 53.151726,146.828979 
	C53.122944,146.680740 53.291645,146.371445 53.709648,145.957977 
z"/>
<path fill="#023C19" opacity="1.000000" stroke="none" 
	d="
M52.758461,147.055618 
	C52.845688,147.238266 52.660992,147.492050 52.248924,147.862778 
	C52.085903,147.654144 52.240902,147.369812 52.758461,147.055618 
z"/>
<path fill="#023C19" opacity="1.000000" stroke="none" 
	d="
M62.686420,75.944305 
	C62.730980,76.108292 62.530132,76.384224 62.125687,76.816902 
	C62.095066,76.667847 62.268040,76.362053 62.686420,75.944305 
z"/>
<path fill="#023C19" opacity="1.000000" stroke="none" 
	d="
M77.709373,57.981735 
	C77.810501,58.180542 77.621834,58.449326 77.188072,58.835678 
	C77.153839,58.689240 77.312706,58.388729 77.709373,57.981735 
z"/>
</svg>
)
}

export default PlainLogoSVG;
